var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.0587V5.97874H18.0213V2H13.9413V5.97874H10.0589V2H5.97895V5.97874H2V10.0587H5.97874V13.9411H2V18.0211H5.97874V22H10.0587V18.0213H13.9411V22H18.0211V18.0213H22V13.9413H18.0213V10.0589L22 10.0587ZM13.9413 10.0587V13.9411H10.0589V10.0589H13.9411L13.9413 10.0587ZM9.96274 9.96274H6.08V6.08H9.96274V9.96274ZM14.0373 14.0373H17.92V17.92H14.0373V14.0373ZM17.92 9.96274H14.0373V6.08H17.92V9.96274ZM9.96274 14.0373V17.92H6.08V14.0373H9.96274Z",
    fill: "#303238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.9e096b8e81c1a9cd9f410cd8be627a10.svg";
export { ForwardRef as ReactComponent };